import { trigger, state, style, animate, transition } from '@angular/animations';

export const SidebarAnim = trigger('sidebarState', [
    state('closed', style({
        transform: 'translateX(-100%)',
        visibility: 'hidden'
    })),
    state('open', style({
        transform: 'translateX(0)',
        visibility: 'visible'
    })),
    transition('closed <=> open', animate('300ms cubic-bezier(0.4, 0.0, 0.2, 1)'))
]);

export const OverlayAnim = trigger('overlayState', [
    state('closed', style({
        opacity: 0,
        visibility: 'hidden'
    })),
    state('open', style({
        opacity: 1,
        visibility: 'visible'
    })),
    transition('closed <=> open', animate('300ms ease-in-out'))
]);
